<div class="my-2 mx-1">
  <div class="flex flex-wrap justify-content-between align-items-start mb-2">
    <button
      type="button"
      pButton
      icon="fa fa-plus"
      label="{{ 'BTN_AGREGAR' | translate }}"
      (click)="onCreate()"
      [disabled]="showForm"
      [loading]="!showForm && (isLoading || saving)"
      *ngIf="!isDetail">
    </button>

    <form
      @slideCollapse
      *ngIf="showForm"
      [formGroup]="form"
      novalidate
      class="form-panel mt-3 mb-2 py-2 w-full create">
      <div class="grid form-group">
        <div class="col-12 md:col-12 lg:col-12 pb-0">
          <span class="text-sm font-semibold" style="color: #5E5E5E;">
            {{ 'LBL_AGREGAR' | translate | uppercase}} {{ 'PRODUCTO_ADJUNTO.LBL_ADJUNTO' | translate | uppercase }}
          </span>
        </div>
        <div class="div-form col-12 md:col-3 lg:col-3">
          <label for="idsTiposVinculaciones">* {{ 'PRODUCTO_ADJUNTO.LBL_TIPO_VINCULACION' | translate }}</label>
          <p-multiSelect
            placeholder="{{ 'LBL_SELECCIONAR' | translate }}"
            selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
            [filter]="true"
            [options]="typesLinkages"
            id="idsTiposVinculaciones"
            name="idsTiposVinculaciones"
            formControlName="idsTiposVinculaciones">
          </p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idsTiposVinculaciones.invalid">
            {{ 'PRODUCTO_ADJUNTO.LBL_TIPO_VINCULACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>

        <div class="div-form col-12 md:col-3 lg:col-3">
          <label for="idsTiposPersonas">* {{ 'PRODUCTO_ADJUNTO.LBL_NATURALEZA' | translate }}</label>
          <p-multiSelect
            placeholder="{{ 'LBL_SELECCIONAR' | translate }}"
            selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
            [filter]="true"
            [options]="typesNatures"
            id="idsTiposPersonas"
            name="idsTiposPersonas"
            formControlName="idsTiposPersonas">
          </p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idsTiposPersonas.invalid">
            {{ 'PRODUCTO_ADJUNTO.LBL_NATURALEZA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>

        <div class="div-form col-12 md:col-3 lg:col-3">
          <label for="idsTiposOcupaciones">* {{ 'PRODUCTO_ADJUNTO.LBL_OCUPACION' | translate }}</label>
          <p-multiSelect
            placeholder="{{ 'LBL_SELECCIONAR' | translate }}"
            selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
            [filter]="true"
            [options]="typesOccupations"
            id="idsTiposOcupaciones"
            name="idsTiposOcupaciones"
            formControlName="idsTiposOcupaciones">
          </p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idsTiposOcupaciones.invalid">
            {{ 'PRODUCTO_ADJUNTO.LBL_OCUPACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>

        <div class="div-form col-12 md:col-3 lg:col-3">
          <label for="idDocumentoTercero">* {{ 'PRODUCTO_ADJUNTO.LBL_ADJUNTO' | translate }}</label>
          <p-dropdown
            placeholder="{{ 'LBL_SELECCIONAR' | translate }}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
            optionValue="value"
            optionLabel="label"
            [filter]="true"
            [options]="attachments"
            id="idDocumentoTercero"
            name="idDocumentoTercero"
            formControlName="idDocumentoTercero">
          </p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idDocumentoTercero.invalid">
            {{ 'PRODUCTO_ADJUNTO.LBL_ADJUNTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>

      <div class="grid form-footer-buttons border-none">
        <div class="form-group col-12 gap-3">
          <button
            type="button"
            pButton
            class="btn-primary-outline shadow-none"
            label="{{ 'BTN_CANCELAR' | translate }}"
            (click)="onCancel()"
            [loading]="saving || isLoading">
          </button>
          <button
            type="submit"
            pButton
            class="shadow-none"
            icon="fa fa-check-circle-o"
            label="{{ 'BTN_GUARDAR'  | translate }}"
            (click)="onSubmit()"
            [loading]="saving || isLoading">
          </button>
        </div>
      </div>
    </form>

    <div class="col-12 md:col-3 lg:col-3 md:ml-auto">
      <span class="new-input-icon">
        <i class="pi pi-search"></i>
        <input
          type="text"
          pInputText
          class="new-input"
          placeholder="{{ 'LBL_BUSCAR' | translate }}"
          (input)="dt.filterGlobal($any($event.target).value, 'contains')">
      </span>
    </div>
  </div>

  <p-table
    #dt
    [columns]="cols"
    [value]="records"
    [loading]="isLoading"
    [paginator]="true"
    [rows]="rows"
    selectionMode="single"
    dataKey="productosAdjuntos.idProductoAdjunto"
    responsiveLayout="scroll"
    styleClass="p-datatable-sm table-premium">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort">
          {{ col.header }}
          <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row.tiposVinculacionesNames }}</td>
        <td>{{ row.tiposPersonasNames }}</td>
        <td>{{ row.tiposOcupacionesNames }}</td>
        <td>{{ row.productosAdjuntos.nombre }}</td>
        <td *ngIf="!isDetail">
          <p-button
            icon="fa fa-trash"
            type="button"
            styleClass="btn-action-premium ml-2"
            data-toggle="tooltip"
            [title]="'BTN_ELIMINAR' | translate"
            [loading]="saving"
            (onClick)="onDelete(row)">
          </p-button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns?.length || 1" class="text-center">
          {{ 'MSG_NOHAYREGISTROS' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog #cd [key]="cdKey">
  <ng-template pTemplate="footer">
    <button type="button" pButton class="btn-primary-outline" icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton class="btn-primary-full" icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
